import React, { useState, useEffect } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Button, IconButton, Select, useDisclosure, Spinner, Text } from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';
import axios from 'axios';
import { BASE_URL } from '../../../Globalapi/Globalapi';

const EditLibrarian = ({ librarianId, schoolId }) => {
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [librarian, setLibrarian] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (librarianId) {
      fetchLibrarianDetails(librarianId);
    }
    fetchTeachers();
  }, [librarianId]);

  const fetchTeachers = async () => {
    setLoading(true);
    try {
      const jwt = sessionStorage.getItem("jwt");
      const school_id = sessionStorage.getItem('school_id'); // If JWT is needed

      const response = await axios.get(
        `${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      console.log(response);
      setTeachers(response.data.data);

      // if (response.data.status === "success") {
      //   setTeachers(response.data.data);
      // } else {
      //   setError(response.data.message || "Error fetching teachers");
      // }
    } catch (error) {
      console.error("Error fetching teachers:", error);
      setError("Network Error: " + (error.message || error));
    } finally {
      setLoading(false);
    }
  };

  const fetchLibrarianDetails = async (librarianId) => {
    setLoading(true);
    try {
      const jwt = sessionStorage.getItem("jwt");
      const response = await axios.get(
        `${BASE_URL}/admin/library/librarian/view_librarian.php?librarian_id=${librarianId}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      if (response.data.success) {
        setLibrarian(response.data.data);
        setSelectedTeacher(response.data.data.teacher_id);  // Assuming 'teacher_id' is returned
      } else {
        setError(response.data.message || "Error fetching librarian details");
      }
    } catch (error) {
      console.error("Error fetching librarian details:", error);
      setError("Network Error: " + (error.message || error));
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = () => {
    onOpen();
  };

  const handleSaveChanges = async () => {
    setLoading(true);
    try {
      const jwt = sessionStorage.getItem("jwt");

      const p = {
        librarian_id: librarianId,
        school_id: schoolId, // Pass the school ID as well
        teacher_id: selectedTeacher,
        user_id: sessionStorage.getItem("user_id"), // This should be replaced with the actual logged-in user ID
      }
      console.log("p", p);

      const response = await axios.put(
        `${BASE_URL}/admin/library/librarian/edit_librarian.php`,
        {
          librarian_id: librarianId,
          school_id: schoolId, // Pass the school ID as well
          teacher_id: selectedTeacher,
          user_id: sessionStorage.getItem("user_id"), // This should be replaced with the actual logged-in user ID
        },
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("editt", response);

      if (response.data.success) {
        // Optionally show success message or update UI
        alert('Librarian updated successfully');
        onClose();
      } else {
        setError(response.data.message || "Failed to update librarian");
      }
    } catch (error) {
      console.error("Error updating librarian:", error);
      setError("Network Error: " + (error.message || error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <IconButton
        icon={<FaEdit />}
        colorScheme="yellow"
        onClick={handleEdit} // Edit action
        aria-label="Edit"
        mr={2}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit Librarian</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {loading ? (
              <Spinner />
            ) : error ? (
              <Text color="red.500">{error}</Text>
            ) : (
              librarian && (
                <>
                  <Select
                    placeholder="Select Teacher"
                    value={selectedTeacher}
                    onChange={(e) => setSelectedTeacher(e.target.value)}
                  >
                    {teachers.map((teacher) => (
                      <option key={teacher.id} value={teacher.id}>
                        {teacher.name}
                      </option>
                    ))}
                  </Select>
                </>
              )
            )}
            <Button mt={4} colorScheme="blue" onClick={handleSaveChanges}>
              Save Changes
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default EditLibrarian;
